export const rules = {
    name: [
        { required: true, message: 'Пожалуйста, введите класс ', trigger: 'blur' },
    ],
    price: [
        { required: true, message: 'Пожалуйста, введите  цена за сутки', trigger: 'blur' },
    ],
};
